import React from "react"

export default function TagsList({tags}) {
  if (!tags || tags.length === 0) {
    return null
  }

  if (tags.length === 1) {
    return (<ul>and tagged as <li> <a key={tags[0]} href={"/blog/tag/" + tags[0]}>{tags[0]}</a></li></ul>)
  }

  return (
    <ul>
      and tagged as
      {tags.map((tag, index) => (
          <li> <a key={tag} href={"/blog/tag/" + tag}>{tag}</a>{index !== (tags.length - 1) ? ',' : ""}</li>
      ))}
    </ul>
  )
}

